import type { RealtyObject } from 'shared/api/kyrgyzstan/search'

import type { DetailSearchParams } from '../model'

export const hasKyrgyzstanDetailSearchParams = (
  searchParams?: DetailSearchParams | null,
): boolean =>
  Boolean(
    searchParams?.start_date ||
    searchParams?.end_date ||
    searchParams?.visitors_count !== undefined ||
    searchParams?.children_ages?.length,
  )

export const getRealtyDefaultStayParams = (
  realty?: RealtyObject | null,
): DetailSearchParams | null => {
  if (
    !realty?.start_date &&
    !realty?.end_date &&
    realty?.visitors_count === undefined
  ) {
    return null
  }

  return {
    ...(realty.start_date ? { start_date: realty.start_date } : {}),
    ...(realty.end_date ? { end_date: realty.end_date } : {}),
    ...(realty.visitors_count !== undefined
      ? { visitors_count: realty.visitors_count }
      : {}),
  }
}

export const getEffectiveStayParams = ({
  searchParams,
  realty,
}: {
  searchParams?: DetailSearchParams | null
  realty?: RealtyObject | null
}): DetailSearchParams | null => {
  if (hasKyrgyzstanDetailSearchParams(searchParams)) {
    return searchParams ?? null
  }

  return getRealtyDefaultStayParams(realty)
}
